import MultiEditTable from './MultiEditTable';

export default MultiEditTable;
